import produce from 'immer';
const enrichClassifications = comparisonDocuments => {
    return produce(comparisonDocuments, draft => {
        draft.forEach(doc => {
            doc.classifications.forEach(classification => {
                var _a, _b, _c, _d;
                classification.category = classification.name.split(':')[0];
                classification.displayName = (_b = (_a = classification.name.split(':')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.trim();
                classification.descriptor = (_d = (_c = classification.name.split(':')) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.trim();
            });
        });
    });
};
export default enrichClassifications;
